import { HttpRequestBuilder15f2nnx9sjuv1 as HttpRequestBuilder } from '../request/HttpRequest.mjs';
import {
  skipSaveBodyqewhiekddpy3 as skipSaveBody,
  get_isSaved1yor47kvbhumv as get_isSaved,
} from '../plugins/SaveBody.mjs';
import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import { unwrapCancellationException1zvbmufui4i9c as unwrapCancellationException } from '../utils/ExceptionUtils.nonJvm.mjs';
import { CancellationException3b36o9qz53rgr as CancellationException } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/cancellation/CancellationException.mjs';
import { save2n0hem2ixzltm as save } from '../call/SavedCall.mjs';
import { get_job2zvlvce9o9a29 as get_job } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Job.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { CompletableJob1w6swnu15iclo as CompletableJob } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CompletableJob.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { Unit_instance28fytmsmm6r23 as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { canceldn4b3cdqcfny as cancel } from '../../../../../ktor-ktor-io/io/ktor/utils/io/ByteReadChannel.mjs';
import { suspendOrReturn49pspzlx5djv as suspendOrReturn } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function *_generator_fetchStreamingResponse__ig8osh($this, $completion) {
  // Inline function 'io.ktor.client.plugins.unwrapRequestTimeoutException' call
  try {
    var builder = (new (HttpRequestBuilder())()).t5k($this.k5w_1);
    skipSaveBody(builder);
    var tmp = $this.l5w_1.n5h(builder, $completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
    var call = tmp;
    return call.d5g();
  } catch ($p) {
    if ($p instanceof CancellationException()) {
      var cause = $p;
      throw unwrapCancellationException(cause);
    } else {
      throw $p;
    }
  }
}
function *_generator_fetchResponse__e29uk9($this, $completion) {
  // Inline function 'io.ktor.client.plugins.unwrapRequestTimeoutException' call
  try {
    var builder = (new (HttpRequestBuilder())()).t5k($this.k5w_1);
    var tmp = $this.l5w_1.n5h(builder, $completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
    var call = tmp;
    var tmp_0 = save(call, $completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
    var result = tmp_0.d5g();
    var tmp_1 = $this.n5w(call.d5g(), $completion);
    if (tmp_1 === get_COROUTINE_SUSPENDED())
      tmp_1 = yield tmp_1;
    return result;
  } catch ($p) {
    if ($p instanceof CancellationException()) {
      var cause = $p;
      throw unwrapCancellationException(cause);
    } else {
      throw $p;
    }
  }
}
function *_generator_cleanup__xwp6uo($this, _this__u8e3s4, $completion) {
  var tmp = get_job(_this__u8e3s4.ew());
  var job = isInterface(tmp, CompletableJob()) ? tmp : THROW_CCE();
  // Inline function 'kotlin.apply' call
  job.w12();
  if (!get_isSaved(_this__u8e3s4)) {
    try {
      cancel(_this__u8e3s4.o5i());
    } catch ($p) {
      if ($p instanceof Error) {
        var _unused_var__etf5q3 = $p;
      } else {
        throw $p;
      }
    }
  }
  var tmp_0 = job.lx($completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  return Unit_instance;
}
var HttpStatementClass;
function HttpStatement() {
  if (HttpStatementClass === VOID) {
    class $ {
      constructor(builder, client) {
        this.k5w_1 = builder;
        this.l5w_1 = client;
      }
      n5y($completion) {
        return this.o5y($completion);
      }
      m5w($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_fetchStreamingResponse__ig8osh.bind(VOID, this), $completion);
      }
      o5y($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_fetchResponse__e29uk9.bind(VOID, this), $completion);
      }
      n5w(_this__u8e3s4, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_cleanup__xwp6uo.bind(VOID, this, _this__u8e3s4), $completion);
      }
      toString() {
        return 'HttpStatement[' + this.k5w_1.g5g_1.toString() + ']';
      }
    }
    initMetadataForClass($, 'HttpStatement', VOID, VOID, VOID, [1, 0]);
    HttpStatementClass = $;
  }
  return HttpStatementClass;
}
//region block: exports
export {
  HttpStatement as HttpStatement3zxb33q8lku,
};
//endregion

//# sourceMappingURL=HttpStatement.mjs.map
